import {CommonRootState} from '../types';

export const selectEcowittConnectedAt = (state: CommonRootState) =>
  state.ecowitt.link && state.ecowitt.link.date_connected;

export const selectEcowittConnected = (state: CommonRootState) =>
  state.ecowitt.link !== null;

export const selectEcowittActive = (state: CommonRootState) =>
  state.ecowitt.link !== null && state.ecowitt.link.account.active;
